export default __webpack_public_path__ + "static/media/nf.8e347812.svg";